//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 안전보건교육 - 교육관리(대상자별) (SAT_BASIC_05) 전용 로직
 * other 케이스에서 사용
 */

// 안전보건교육 - 교육관리(대상자별) 조회 함수
export const SearchLogic1 = async (apiUrl, procedureParams, dispatch, setLoading) => {
  setLoading(true);

  try {
    const result = await apiRequest(
      'post',
      apiUrl,
      procedureParams
    );

    let data = result.data;
    if (data.length === 0) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'info',
        })
      );
      return [];
    } else if (data[0]?.type === 'Error') {
      dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
      return [];
    } else {
      // alarmGubun 코드를 이름으로 변환
      const processedData = data.map((item) => {
        // alarmGubun 코드 변환 (0 -> 7일전, 1 -> 3일전, 2 -> 1일전)
        let alarmGubun = item.alarmGubun;
        if (alarmGubun !== undefined && alarmGubun !== null) {
          const codeMap = {
            0: '7일전',
            1: '3일전',
            2: '1일전',
          };
          alarmGubun = codeMap[alarmGubun] || alarmGubun;
        }

        return {
          ...item,
          alarmGubun: alarmGubun,
        };
      });

      return Commons.InsertNumber(processedData);
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return [];
  } finally {
    setLoading(false);
  }
};

// 안전보건교육 - 교육관리(대상자별) 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터 (사용하지 않지만 시그니처 통일을 위해 유지)
  dispatch,
  setLoading,
  rowData1, // 전체 리스트
  searchRef
) => {
  setLoading(true);

  try {
    if (!rowData1 || rowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    // HeaderData 설정
    const headerData = {
      YEAR: searchRef?.current?.currentYear,
    };

    // TableData 매핑 (레포트 양식에 맞게)
    const tableData = rowData1
      .filter((row) => !row.deleteYn) // 삭제된 행 제외
      .map((row, index) => {
        // 알람 컬럼: "Y, 7일전 11-30" 형식으로 변환
        let alarmText = '';
        if (row.alarmYn === 'Y' || row.alarmYn === 'y') {
          const alarmGubun = row.alarmGubun || '';
          // ALARM_DATE가 있으면 MM-DD 형식으로 변환
          let alarmDateStr = '';
          if (row.alarmDate && dayjs(row.alarmDate).isValid()) {
            alarmDateStr = dayjs(row.alarmDate).format('MM-DD');
          } else if (
            row.completeDate &&
            dayjs(row.completeDate).isValid()
          ) {
            // ALARM_DATE가 없으면 COMPLETE_DATE 사용
            alarmDateStr = dayjs(row.completeDate).format('MM-DD');
          }

          if (alarmGubun && alarmDateStr) {
            alarmText = `Y, ${alarmGubun} ${alarmDateStr}`;
          } else if (alarmGubun) {
            alarmText = `Y, ${alarmGubun}`;
          } else {
            alarmText = 'Y';
          }
        } else if (row.alarmYn === 'N' || row.alarmYn === 'n') {
          alarmText = 'N';
        } else {
          alarmText = row.alarmYn || '';
        }

        return {
          NO: index + 1,
          USER_NM: row.userNm || '', // 성명
          DEP_NM: row.depNm || '', // 소속(팀명)
          POSITION: row.position || '', // 직급
          ETC_EDU_NM: row.etcEduNm || '', // 교육명
          EDU_COUNT: row.eduCount || 0, // 등록교육수
          COMPLETE_COUNT: row.completeCount || 0, // 이수완료건
          NO_COMPLETE_COUNT: row.noCompleteCount || 0, // 미이수건
          ALARM: alarmText, // 알람 (이수종료일 7일전, 3일전, 1일전) - "Y, 7일전 11-30" 형식
        };
      });

    const printData = {
      FileName: 'TRA_BASIC_07',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

